import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConstantsModule } from './../constants/constants.module';

import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-folder-updater',
	templateUrl: './folder-updater.component.html',
	styleUrls: ['./folder-updater.component.scss']
})
export class FolderUpdaterComponent extends DialogPage implements OnInit {

	public folderId: string = "";
	public folderName: string = "";

	active = 1;
	folderUpdaterForm = new FormGroup({
		subjectUpdaterControl: new FormControl('', [Validators.required]),
		emailUpdaterControl: new FormControl('', [Validators.required]),
		whoControl: new FormControl("ALL", [Validators.required]),
		sendToAdminsControl: new FormControl(true),
		sendToEngineerControl: new FormControl(true),
	});

	// Extra data.
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule:ConstantsModule, cookieService: CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Send button.
		this.buttonText = "Envoyer";
		this.enableAction = true;
	}

	ngOnInit(): void {
		this.folderUpdaterForm.controls["subjectUpdaterControl"].setValue(this.constantsModule.mailTemplateFolderUpdaterSubject);
		this.folderUpdaterForm.controls["emailUpdaterControl"].setValue(this.constantsModule.mailTemplateFolderUpdater);
	}

	public setModalOptions(data:any): void {
		this.folderId = data["id"];
	}

	public doSend(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			folderid: this.folderId,
			subject:this.folderUpdaterForm.controls["subjectUpdaterControl"].value,
			email:this.folderUpdaterForm.controls["emailUpdaterControl"].value,
			sendToAdmins: this.folderUpdaterForm.controls['sendToAdminsControl'].value,
			sendToEngineer: this.folderUpdaterForm.controls['sendToEngineerControl'].value,
    		who: this.folderUpdaterForm.controls['whoControl'].value,
		};
		this.put("/api/folder-updater", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					var data = {
						DATA:"OK", 
						NB: response.NB,
					};
					this.modalInstance.dismiss(data);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
